'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002415 from "./presto.-Register-Page-View$$anon$15.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002417 from "./presto.-Register-Page-View$$anon$17.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00245 from "./presto.-Register-Page-View$$anon$5.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00247 from "./presto.-Register-Page-View$$anon$7.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024 from "./presto.types$-Single-App-User$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$4() {
  this.buj = null;
  this.bub = null;
  this.buc = false;
  this.buk = null;
  this.bul = false;
  this.buo = null;
  this.buh = null;
  this.bui = false;
  this.bud = null;
  this.bue = false;
  this.buf = null;
  this.bug = false;
  this.bum = false;
  this.bun = false;
  this.buj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.buo = "SingleAppUser";
}
export { $c_Lpresto_RegisterPageView$$anon$4 as $c_Lpresto_RegisterPageView$$anon$4 };
$p = $c_Lpresto_RegisterPageView$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$4;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$4() {
}
export { $h_Lpresto_RegisterPageView$$anon$4 as $h_Lpresto_RegisterPageView$$anon$4 };
$h_Lpresto_RegisterPageView$$anon$4.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.buj;
});
$p.L = (function() {
  if ((!this.buc)) {
    this.bub = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.buc = true;
  }
  return this.bub;
});
$p.O = (function() {
  if ((!this.bul)) {
    this.buk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bul = true;
  }
  return this.buk;
});
$p.E = (function() {
  return this.buo;
});
$p.t = (function() {
  if ((!this.bui)) {
    this.buh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("details", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("application", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("impersonatedBy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bui = true;
  }
  return this.buh;
});
$p.M = (function() {
  if ((!this.bue)) {
    this.bud = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00245.$c_Lpresto_RegisterPageView$$anon$5(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00247.$c_Lpresto_RegisterPageView$$anon$7(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002415.$c_Lpresto_RegisterPageView$$anon$15())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.bue = true;
  }
  return this.bud;
});
$p.Q = (function() {
  if ((!this.bug)) {
    this.buf = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002417.$c_Lpresto_RegisterPageView$$anon$17();
    this.bug = true;
  }
  return this.buf;
});
$p.w = (function() {
  if ((!this.bun)) {
    this.bum = false;
    this.bun = true;
  }
  return this.bum;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee117) => ((p) => \u03b4scrutinee117.adc(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024.$m_Lpresto_types$SingleAppUser$())));
});
var $d_Lpresto_RegisterPageView$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$4, "presto.RegisterPageView$$anon$4", ({
  Q2: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$4 as $d_Lpresto_RegisterPageView$$anon$4 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$4.js.map
